import Plural from 'components/utils/Formatters/Plural'
import config from 'constants/config'
import React from 'react'

interface Props {
  statusCredits: number
}

function FormatLoyaltyStatusCredits({ statusCredits }: Props) {
  return <Plural
    singular={config.loyalty.statusCreditsUnit}
    count={statusCredits}
    withCount
  />
}

export default FormatLoyaltyStatusCredits
